import { LocaleLink } from '../../../i18n/locale-link';

interface Props {
  links: { label: string; href: string }[];
  legal: string;
}

/** Футер лендинга: свой, минимальный — см. `landing-header.tsx`. */
export function LandingFooter({ links, legal }: Props) {
  return (
    <footer className="pb-28 pt-9 text-sm text-ink-soft sm:pb-11">
      <div className="mx-auto max-w-[1120px] px-5">
        <div className="mb-4 flex flex-wrap gap-x-6 gap-y-2.5">
          {links.map((l) =>
            l.href.startsWith('http') || l.href.startsWith('tel:') ? (
              <a key={l.href} className="text-ink-soft" href={l.href}>
                {l.label}
              </a>
            ) : (
              <LocaleLink key={l.href} className="text-ink-soft" to={l.href}>
                {l.label}
              </LocaleLink>
            ),
          )}
        </div>
        <div>{legal}</div>
      </div>
    </footer>
  );
}
